module.exports = __webpack_public_path__ + "static/img/3.3affa40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/3.png
// module id = BR0w
// module chunks = 0